import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Avatar, CircularProgress } from "@mui/material";
import avatarImage from "../img/avatar.jpeg";
import { Form, Row, Col, Button } from "react-bootstrap";
import "react-phone-number-input/style.css";
import { useRef, useState } from "react";
import PhoneInputWithCountrySelect from "react-phone-number-input";
import { NavLink, useNavigate } from "react-router-dom";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import useAxiosRequests from "../hooks/useAxiosRequest";
import ExternalRoutes from "../config/ExternalRoutes";
import { useContext } from "react";
import AuthContext from "../context/AuthContext";
import { API_BASE_URL } from "../config/BaseUrl";
import { MessageContext } from "../context/MessageContext";

export const Informations = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const fileInputRef = useRef(null);
  const { sendRequest } = useAxiosRequests();
  const navigate = useNavigate();
  const { userInfo, updateUserInfo } = useContext(AuthContext);
  const { showSuccess, showError } = useContext(MessageContext);
  const [loading, setLoading] = useState(false);

  const baseUrl = API_BASE_URL;

  const validationSchema = Yup.object().shape({
    prenom: Yup.string().required("Le prénom est requis"),
    usrType: Yup.string()
      .oneOf(["1", "2"], "Le type d'utilisateur est invalide")
      .required("Le type d'utilisateur est requis"),
    nom: Yup.string().required("Le nom est requis"),
    telephone: Yup.string()
      .required("Le téléphone est requis")
      .matches(/^\+?[0-9]{10,15}$/, "Numéro de téléphone invalide"),
    email: Yup.string()
      .email("Adresse e-mail invalide")
      .nullable(),
    fichier: Yup.mixed()
      .nullable()
      .test(
        "fileSize",
        "Le fichier est trop volumineux (maximum 12MB)",
        (value) => !value || (value && value.size <= 12 * 1024 * 1024)
      )
      .test(
        "fileType",
        "Format de fichier non supporté (images uniquement)",
        (value) =>
          !value ||
          (value &&
            ["image/jpeg", "image/png", "image/gif"].includes(value.type))
      ),
  });

  const onHandleSubmit = async (values, { setSubmitting }) => {
    console.log(values);
    setLoading(true);
    try {
      const body = new FormData();
      Object.keys(values).forEach((key) => {
        if (values[key] !== null && values[key] !== undefined) {
          body.append(key, values[key]);
        }
      });

      const response = await sendRequest({
        method: "POST",
        url: ExternalRoutes.userInformation.edit,
        body: body,
      });

      if (response.status === "success" && response.message) {
        showSuccess(response.message);
        const userData = response.data;
        updateUserInfo(userData);
        navigate("/customer");
      } else if (response.status !== "success" && response.message) {
        showError(response.message);
      } else {
        showError("Une erreur inattendue est survenue.");
      }
    } catch (error) {
      return error;
    } finally {
      setSubmitting(false);
      setLoading(false);
    }
  };


  return (
    <>
      <div>
        <div className="kl-admin-header">
          <button
            onClick={() => navigate("/customer")}
            className="p-0 kl-back-button"
          >
            <FontAwesomeIcon icon={faArrowLeft} className="kl-icon-arrow" />
          </button>
          <div className="kl-logo-contab">
            <span>Informations</span>
          </div>
          <button className="kl-button-profile"></button>
        </div>

        <Formik
          initialValues={{
            prenom: userInfo?.firstName || "",
            nom: userInfo?.lastName || "",
            telephone: userInfo?.tel || "",
            email: userInfo?.email || "",
            fichier: null,
            usrType: userInfo?.usrType?.toString() || "",
          }}
          validationSchema={validationSchema}
          onSubmit={onHandleSubmit}
          validateOnChange
        >
          {({
            handleSubmit,
            isValid,
            isSubmitting,
            setFieldValue,
            setFieldTouched,
            values,
            errors,
            touched,
          }) => (
            <form
              noValidate
              autoComplete="off"
              onSubmit={handleSubmit}
              className="kl-profile-form"
            >
              <div className="kl-profile-editor-container">
                <div className="kl-profile-picture-wrapper">
                  <label htmlFor="profile-upload" className="kl-profile-picture-label">

                    <Avatar
                      alt="Remy Sharp"
                      src={selectedImage || (userInfo && userInfo?.photo ? `${baseUrl}${userInfo?.photo}` : avatarImage)}
                      sx={{ width: 90, height: 90 }}
                    />

                    <div className="kl-camera-icon">
                      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M22.9866 30.3332H9.01324C5.27991 30.3332 2.90657 28.1065 2.69324 24.3865L1.99991 13.3865C1.89324 11.7198 2.46657 10.1198 3.61324 8.9065C4.74657 7.69317 6.34657 6.99984 7.99991 6.99984C8.42657 6.99984 8.83991 6.7465 9.03991 6.3465L9.99991 4.43984C10.7866 2.87984 12.7599 1.6665 14.4799 1.6665H17.5332C19.2532 1.6665 21.2132 2.87984 21.9999 4.4265L22.9599 6.37317C23.1599 6.7465 23.5599 6.99984 23.9999 6.99984C25.6532 6.99984 27.2532 7.69317 28.3866 8.9065C29.5332 10.1332 30.1066 11.7198 29.9999 13.3865L29.3066 24.3998C29.0666 28.1732 26.7599 30.3332 22.9866 30.3332ZM14.4799 3.6665C13.4932 3.6665 12.2399 4.43984 11.7866 5.33317L10.8266 7.25317C10.2666 8.33317 9.18657 8.99984 7.99991 8.99984C6.87991 8.99984 5.83991 9.45317 5.06657 10.2665C4.30657 11.0798 3.91991 12.1465 3.99991 13.2532L4.69324 24.2665C4.85324 26.9598 6.30657 28.3332 9.01324 28.3332H22.9866C25.6799 28.3332 27.1332 26.9598 27.3066 24.2665L27.9999 13.2532C28.0666 12.1465 27.6932 11.0798 26.9332 10.2665C26.1599 9.45317 25.1199 8.99984 23.9999 8.99984C22.8132 8.99984 21.7332 8.33317 21.1732 7.27984L20.1999 5.33317C19.7599 4.45317 18.5066 3.67984 17.5199 3.67984H14.4799V3.6665Z" fill="white" />
                        <path d="M18 11.6665H14C13.4533 11.6665 13 11.2132 13 10.6665C13 10.1198 13.4533 9.6665 14 9.6665H18C18.5467 9.6665 19 10.1198 19 10.6665C19 11.2132 18.5467 11.6665 18 11.6665Z" fill="white" />
                        <path d="M16.0003 25.0002C13.0537 25.0002 10.667 22.6135 10.667 19.6668C10.667 16.7202 13.0537 14.3335 16.0003 14.3335C18.947 14.3335 21.3337 16.7202 21.3337 19.6668C21.3337 22.6135 18.947 25.0002 16.0003 25.0002ZM16.0003 16.3335C14.1603 16.3335 12.667 17.8268 12.667 19.6668C12.667 21.5068 14.1603 23.0002 16.0003 23.0002C17.8403 23.0002 19.3337 21.5068 19.3337 19.6668C19.3337 17.8268 17.8403 16.3335 16.0003 16.3335Z" fill="white" />
                      </svg>
                    </div>
                  </label>
                  <input
                    ref={fileInputRef}
                    id="profile-upload"
                    name="fichier"
                    type="file"
                    accept="image/*"
                    onChange={(event) => {
                      const file = event.target.files[0];
                      setFieldTouched("fichier", true);
                      setFieldValue("fichier", file);
                      if (file) {
                        setSelectedImage(URL.createObjectURL(file));
                      }
                    }}
                    style={{ display: "none" }}
                  />
                </div>
                <ErrorMessage
                  name="fichier"
                  component="small"
                  className="text-danger d-block mt-1"
                />
                <p
                  className="kl-change-photo-text"
                  onClick={() => fileInputRef.current.click()}
                >
                  Changer la photo
                </p>
              </div>

              <div className="kl-form-control kl-form-information">
                <Row className="gx-3 mb-3">
                  <Col xs={6}>
                    <Form.Group className="kl-form-group" controlId="formFirstName">
                      <Form.Label>Prénom</Form.Label>
                      <Field
                        as={Form.Control}
                        type="text"
                        name="prenom"
                        className={`kl-input-form ${touched.prenom && errors.prenom ? "is-invalid" : ""
                          }`}
                      />
                      <ErrorMessage
                        name="prenom"
                        component="small"
                        className="text-danger d-block mt-1"
                      />
                    </Form.Group>
                  </Col>
                  <Col xs={6}>
                    <Form.Group className="kl-form-group" controlId="formLastName">
                      <Form.Label>Nom</Form.Label>
                      <Field
                        as={Form.Control}
                        type="text"
                        name="nom"
                        className={`kl-input-form ${touched.nom && errors.nom ? "is-invalid" : ""
                          }`}
                      />
                      <ErrorMessage
                        name="nom"
                        component="small"
                        className="text-danger d-block mt-1"
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <Form.Label>Vous êtes</Form.Label>
                <Form.Group className="kl-form-check-group kl-form-group">
                  <div className="flex-column ">
                    <div className="d-flex kl-radios ">
                      <div className={`kl-radio-item ${touched.usrType && errors.usrType ? 'kl-radio-error' : ''}`}>
                        <Form.Check
                          type="radio"
                          id="id-reverse-1"
                          name="usrType"
                          label="TAXI"
                          value="1"
                          checked={values.usrType === "1"}
                          onChange={() => setFieldValue("usrType", "1")}
                          className={`kl-input-form ${touched.usrType && errors.usrType ? 'is-invalid' : ''}`}
                        />
                      </div>

                      <div className={`kl-radio-item ${touched.usrType && errors.usrType ? 'kl-radio-error' : ''}`}>
                        <Form.Check
                          type="radio"
                          id="id-reverse-2"
                          name="usrType"
                          label="VTC"
                          value="2"
                          checked={values.usrType === "2"}
                          onChange={() => setFieldValue("usrType", "2")}
                          className={`kl-input-form ${touched.usrType && errors.usrType ? 'is-invalid' : ''}`}
                        />
                      </div>
                    </div>
                    <ErrorMessage
                      name="usrType"
                      component="div"
                      className="text-danger d-block"
                      style={{ fontSize: '0.875rem' }}
                    />
                  </div>
                </Form.Group>

                <Form.Group controlId="formPhoneNumber" className="kl-form-group">
                  <Form.Label>Téléphone</Form.Label>
                  <PhoneInputWithCountrySelect
                    international
                    defaultCountry="FR"
                    value={values.telephone}
                    onChange={(value) => {
                      setFieldValue("telephone", value);
                    }}
                    className="kl-input-form kl-input-select-phone"
                  />
                  <ErrorMessage
                    name="telephone"
                    component="small"
                    className="text-danger d-block mt-1"
                  />
                </Form.Group>

                <Form.Group className="kl-form-group">
                  <Form.Label>Email</Form.Label>
                  <div className="mb-4">
                    <div className="kl-input-container">
                      <div className="kl-fa-icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M14.167 17.2082H5.83366C4.40774 17.2082 3.35103 16.7997 2.65075 16.0994C1.95047 15.3991 1.54199 14.3424 1.54199 12.9165V7.08317C1.54199 5.65725 1.95047 4.60055 2.65075 3.90027C3.35103 3.19999 4.40774 2.7915 5.83366 2.7915H14.167C15.5929 2.7915 16.6496 3.19999 17.3499 3.90027C18.0502 4.60055 18.4587 5.65725 18.4587 7.08317V12.9165C18.4587 14.3424 18.0502 15.3991 17.3499 16.0994C16.6496 16.7997 15.5929 17.2082 14.167 17.2082ZM5.83366 3.0415C4.5685 3.0415 3.53163 3.34892 2.81552 4.06503C2.09941 4.78115 1.79199 5.81802 1.79199 7.08317V12.9165C1.79199 14.1817 2.09941 15.2185 2.81552 15.9346C3.53164 16.6508 4.5685 16.9582 5.83366 16.9582H14.167C15.4321 16.9582 16.469 16.6508 17.1851 15.9346C17.9012 15.2185 18.2087 14.1817 18.2087 12.9165V7.08317C18.2087 5.81801 17.9012 4.78115 17.1851 4.06503C16.469 3.34892 15.4321 3.0415 14.167 3.0415H5.83366Z" fill="#292D32" stroke="#9CA3AF" />
                          <path d="M8.36595 9.67913L8.36597 9.67911L8.36202 9.67596L5.75588 7.59438C5.69372 7.54298 5.69609 7.46498 5.7297 7.4236C5.78109 7.36036 5.85974 7.36256 5.90135 7.39637L5.90134 7.39638L5.90461 7.39899L8.512 9.48158C8.51216 9.48171 8.51232 9.48184 8.51248 9.48196C8.93375 9.81987 9.47734 9.97289 9.99581 9.97289C10.5143 9.97289 11.0579 9.81987 11.4791 9.48196C11.4793 9.48184 11.4795 9.48171 11.4796 9.48158L14.087 7.39899L14.087 7.399L14.0903 7.39637C14.1445 7.35231 14.2193 7.36783 14.2514 7.41024L14.2566 7.41701L14.2619 7.4236C14.306 7.47783 14.2905 7.55264 14.2481 7.58476L14.248 7.58463L14.2379 7.59263L11.6296 9.67596L11.6296 9.6759L11.6227 9.68155C11.1932 10.0372 10.6033 10.225 9.99998 10.225C9.39752 10.225 8.80565 10.0377 8.36595 9.67913Z" fill="#292D32" stroke="#9CA3AF" />
                        </svg>
                      </div>
                      <Field
                        as={Form.Control}
                        type="email"
                        name="email"
                        className={`kl-input-login ${touched.email && errors.email ? "is-invalid" : ""
                          }`}
                        placeholder="Votre email..."
                        size="lg"
                      />
                    </div>
                    <ErrorMessage
                      name="email"
                      component="small"
                      className="text-danger mb-2"
                    />
                  </div>
                </Form.Group>
                <div className="kl-list-button-info-only-pwd">
                  <div className="kl-button-information kl-button-change-password">
                    <span className="d-flex align-items-center">
                      <div className="kl-profile-icons">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M9.99968 18.9668C9.09135 18.9668 8.19136 18.7002 7.48302 18.1752L3.89967 15.5002C2.94967 14.7918 2.20801 13.3168 2.20801 12.1335V5.94183C2.20801 4.65849 3.14969 3.29183 4.35802 2.84183L8.51635 1.2835C9.34135 0.975163 10.6414 0.975163 11.4664 1.2835L15.633 2.84183C16.8414 3.29183 17.783 4.65849 17.783 5.94183V12.1335C17.783 13.3168 17.0413 14.7918 16.0913 15.5002L12.508 18.1752C11.808 18.7002 10.908 18.9668 9.99968 18.9668ZM8.95801 2.45016L4.79969 4.00849C4.08302 4.27515 3.45801 5.17516 3.45801 5.94183V12.1335C3.45801 12.9252 4.01635 14.0335 4.64135 14.5002L8.22468 17.1751C9.18301 17.8918 10.808 17.8918 11.7663 17.1751L15.3497 14.5002C15.983 14.0252 16.533 12.9168 16.533 12.1335V5.94183C16.533 5.18349 15.908 4.28349 15.1914 4.00849L11.033 2.45016C10.483 2.24182 9.51635 2.24182 8.95801 2.45016Z" fill="#5379F6" />
                          <path d="M9.9996 9.72481C9.98293 9.72481 9.96626 9.72481 9.94126 9.72481C8.73293 9.69148 7.84961 8.76648 7.84961 7.64148C7.84961 6.49148 8.79126 5.5498 9.94126 5.5498C11.0913 5.5498 12.0329 6.49148 12.0329 7.64148C12.0246 8.77481 11.1413 9.69146 10.0163 9.73313C10.0079 9.7248 10.0079 9.72481 9.9996 9.72481ZM9.94126 6.7998C9.47459 6.7998 9.09961 7.17481 9.09961 7.64148C9.09961 8.09981 9.45794 8.46646 9.90794 8.48313C9.90794 8.48313 9.9496 8.48313 9.9996 8.48313C10.4413 8.45813 10.7829 8.09148 10.7829 7.64148C10.7913 7.17481 10.4079 6.7998 9.94126 6.7998Z" fill="#5379F6" />
                          <path d="M10 14.4585C9.28334 14.4585 8.55835 14.2668 8.00002 13.8918C7.44168 13.5251 7.125 12.9835 7.125 12.4085C7.125 11.8335 7.44168 11.2918 8.00002 10.9168C9.12502 10.1668 10.8833 10.1751 12 10.9168C12.5583 11.2835 12.875 11.8251 12.875 12.4001C12.875 12.9751 12.5583 13.5168 12 13.8918C11.4417 14.2668 10.7167 14.4585 10 14.4585ZM8.69167 11.9501C8.48334 12.0835 8.36667 12.2501 8.375 12.4001C8.375 12.5501 8.49167 12.7168 8.69167 12.8501C9.39167 13.3168 10.6083 13.3168 11.3083 12.8501C11.5167 12.7168 11.6333 12.5501 11.6333 12.4001C11.6333 12.2501 11.5167 12.0835 11.3167 11.9501C10.6167 11.4918 9.39167 11.4918 8.69167 11.9501Z" fill="#5379F6" />
                        </svg>
                      </div>
                      <NavLink className="kl-link-to" to="/change-password">
                        Changer mot de passe
                      </NavLink>
                    </span>
                    <div className="kl-profile-arrowRight">
                      <NavLink className="kl-link-to" to="/change-password">
                        <FontAwesomeIcon icon={faArrowRight} />
                      </NavLink>
                    </div>
                  </div>

                </div>
              </div>

              <div className="kl-actions-container kl-button-information-valided text-center">
                <Button
                  type="submit"
                  variant={isValid ? "primary" : "secondary"}
                  className="kl-button-valider"
                  disabled={!isValid || loading}
                >
                  {
                    loading ?
                      <>
                        <CircularProgress size={15} color="inherit" />
                        <span className="mx-2">Validation en cours...</span>

                      </>
                      : "Valider"
                  }
                  {/* {isSubmitting ? "Validation en cours..." : "Valider"} */}
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </>
  );
};